var React = require('react');

function EcoLightbulb (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none"},[React.createElement("path",{"d":"M7.547 9.619c-.465 1.946.158 3.638 3.425 2.877 2.568 2.157 3.842 1.135 4.355-1.014.515-2.148-1.034-6.417-3.232-7.972-1.185 2.803-3.965 3.678-4.548 6.109zM9 20.5h5M9 22.5h5M11.5 22.5v1M11.5 18.5s-1.555-7.863.526-11.168","key":0}),React.createElement("path",{"d":"M20.5 9c0-4.693-4.03-8.5-9-8.5-4.971 0-9 3.807-9 8.5 0 3.874 2.747 7.137 6.5 8.161v1.339h5v-1.339c3.753-1.024 6.5-4.287 6.5-8.161z","key":1})]));
}

EcoLightbulb.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = EcoLightbulb;

EcoLightbulb.default = EcoLightbulb;
